<p-panel header="{{ 'fs.res.common.prizeNominations' | hisUi }}">
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<div class="selectAndTableCombination">	
		<his-plam [showLabelTop]="true">
			<p-autoComplete #content
			    [disabled]="!editMode"
				[hisDdKey]="dDKey"
				[(ngModel)]="selectedNomination"
				hisLazyDataSource="api/v1/fs/res/nomination"
				field="fullName" 
				[minLength]="1"
				[forceSelection]="true"
				class="autocompleteWidth100" 
				(onSelect)="onSelectByAutocomplete()">
			</p-autoComplete>
		    
			<his-search-select-popup
			    [editMode]="editMode"
				searchConfigFile="{{SEARCH_CONFIG_MINI_NOMINATION}}"
				[selectedOptions]="getSelectedNominations()"
				selectedOptionsIdColumn="Nomination.id"
				[showDeleteButton]="false"
				(selectedOptionsChange)="onSelectBySearchPopup($event)">
			</his-search-select-popup>
		</his-plam>
		<div *ngIf="getSelectedNominations()?.length > 0">
			<div class="clearAndSpace"></div>
			<p-table [value]="getSelectedNominations()">
			    <ng-template pTemplate="header">
					<tr>
						<th>{{'fs.res.prizeNomination.Prize.title' | hisUi}}</th>
					    <th>{{'fs.res.prizeNomination.Nomination.nominationYear' | hisUi}}</th>
					    <th>{{'fs.res.prizeNomination.Prize.prizeCategory' | hisUi}}</th>
                        <th>{{'fs.res.prizeNomination.Nomination.nameAddition' | hisUi}}</th>
	            		<th>{{'fs.res.prizeNomination.Nomination.nominatedPersons' | hisUi}}</th>
					    <th>{{'common.actions' | hisUi }}</th>
			        </tr>
			    </ng-template>
			    <ng-template pTemplate="body" let-index="rowIndex" let-nomination>
			        <tr>
			            <td>{{nomination.prize.title}}</td>
					    <td>{{nomination.nominationYear}}</td>
                        <td>{{nomination.prize.category.defaulttext}}</td>
					    <td>{{nomination.nameAddition}}</td>
					    <td>
							<span *ngFor="let item of nomination.nominatedPersons">{{item.person.surname}}, {{item.person.firstname}}<br/></span>
					    </td>
			            <td class="singleLine">
							<button (click)="removeNomination(nomination)" hisImage="DELETE" [disabled]="!editMode" class="icon" 
                                title="{{'common.removeAssignmentOf' | hisUi:(nomination.prize.title)}}"></button>
				        </td>
				    </tr>
				</ng-template>
			</p-table>
		</div>
	</div>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
</p-panel>
